var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCenterLight = function SvgCenterLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#center-light_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.657 6.157a.5.5 0 0 0 .5-.5v-4.5a.5.5 0 1 0-1 0v4h-4a.5.5 0 0 0 0 1zM-.353.354 5.302 6.01l.707-.707L.354-.354zM6.157 10.343a.5.5 0 0 0-.5-.5h-4.5a.5.5 0 1 0 0 1h4v4a.5.5 0 1 0 1 0zm-5.803 6.01 5.656-5.656-.707-.707-5.657 5.656zM10.343 9.843a.5.5 0 0 0-.5.5v4.5a.5.5 0 1 0 1 0v-4h4a.5.5 0 1 0 0-1zm6.01 5.803L10.698 9.99l-.707.707 5.656 5.657zM9.843 5.657a.5.5 0 0 0 .5.5h4.5a.5.5 0 1 0 0-1h-4v-4a.5.5 0 1 0-1 0zm5.803-6.01L9.99 5.302l.707.707L16.354.354z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "center-light_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgCenterLight;